import { render, staticRenderFns } from "./ImageInformationStudy.vue?vue&type=template&id=387c79e8&"
import script from "./ImageInformationStudy.vue?vue&type=script&lang=js&"
export * from "./ImageInformationStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports